import { ICookieDelay, IUser, useMainStore } from "src/settings/zustand"; 
import { showAccessToast } from "../useful/AppToaster";
import { __ } from "./i18n";
import { Button, ButtonVariant, Intent, OverlayToaster, Size, } from "@blueprintjs/core";
import { ACCESS_COOKIES_DELAY } from "../interfaces/layouts";

export default function checkAccessCookies ( user?: IUser ): Promise<any> {
    let instance: OverlayToaster | undefined = undefined
    const  onAccept = () => {
        
        //console.log(  instance?.state.toasts )
        //console.log(  instance )
        instance?.clear()
    }
    const  onDelay = () => {
        if(!user) {
            user = useMainStore.getState().user
        }
        const accessCookiesDelay: ICookieDelay[] = [
            ...useMainStore.getState().accessCookiesDelay.filter((d: ICookieDelay) => d.user_id !== user?.id),
            { user_id: user?.id, delay: Date.now() }
        ]
        useMainStore.setState({ accessCookiesDelay })
        instance?.clear()
    }
    const  omGotoPolicy = () => {

    }
    const getToast = () => {
        showAccessToast({
            message: <div className="max-width d-flex align-items-center ">
                <div className="flex-grow-100 mx-2">
                    <div className="">{__( "Мы используем cookie для персонализации сервисов и удобства пользователей. Вы можете запретить сохранение cookie в настройках своего браузера." )}</div>
                </div>
                <Button size={Size.SMALL} intent={Intent.SUCCESS} className="mr-1" onClick={onAccept}>
                    <div className="small">{__("Хорошо")}</div>
                </Button>
                {/* 
                {
                    !useMainStore.getState().accessCookiesDelay.filter((d: ICookieDelay) => d.user_id !== user?.id).length && 
                    <Button size={Size.SMALL} intent={Intent.DANGER} className="mr-1" onClick={onDelay}>
                        <div className="small">{__("Delay access for 3 days.")}</div>
                    </Button>
                } 
                <Button size={Size.SMALL} variant={ButtonVariant.MINIMAL} onClick={omGotoPolicy}>
                    <div className="small">{__("Privacy Policy")}</div>
                </Button>
                */} 
            </div>,
            timeout: 200000,
        })
        .then((res: any ) => {
            instance = res 
        })
    }
    return new Promise<any>((resolve, reject) => {
        
        if(!user) {
            user = useMainStore.getState().user
        }
        if( !!user?.id) {
            // console.log( user )        
            if(!user.is_accessed_cookies) {
                const accessCookiesDelay: ICookieDelay = useMainStore.getState().accessCookiesDelay.find((d: ICookieDelay) => d.user_id === user!.id)
                if( !!accessCookiesDelay && Date.now() - accessCookiesDelay.delay < ACCESS_COOKIES_DELAY ) {
                    resolve( true )
                }
                else {
                    getToast()
                    resolve( false )
                }
            }
            resolve( false )
        }
        resolve( false )
    })
}